@if (alertSucesso === true) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/success.png" width="82px" alt="Sucesso">
      <p class="titulo-alert"> {{ alertSucessoSubtitulo }} </p>
      <div class="footer-alert">
        <p class="subtitulo-alert"> {{ alertSucessoMensagem }} </p>
        @if (alertSucessoSubtitulo == 'Importação realizada com sucesso!') {
          <button class="botao-secundario mt-3 me-3" (click)="alertSucessoAvancou.emit()" id="avancarImportacao"
            [tag]="addTagManagerInteraction('box:button:click', 'avancar')"
          >AVANÇAR</button>
        }
        <button class="botao-secundario-outline mt-3" (click)="fecharAlertSucesso()" id="sair"
          [tag]="addTagManagerInteraction('box:button:click', 'sair')"
        >SAIR</button>
      </div>
    </div>
  </div>
}
